import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from '../../contexts/ToastContext';
import { STORAGE_KEYS } from '../../constants';

const OAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showToast } = useToast();

  useEffect(() => {
    const handleCallback = async () => {
      // Get token from URL params
      const token = searchParams.get('token');
      const error = searchParams.get('error');

      if (error) {
        showToast(error, 'error');
        navigate('/login');
        return;
      }

      if (!token) {
        showToast('Authentication failed. No token received.', 'error');
        navigate('/login');
        return;
      }

      try {
        localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, token);

        const redirectTo = sessionStorage.getItem('oauth_redirect') || '/dashboard';
        sessionStorage.removeItem('oauth_redirect');

        showToast('Successfully signed in!', 'success');

        // Force reload so AuthProvider re-initializes and fetches the user.
        window.location.href = redirectTo;
      } catch (authError) {
        console.error('OAuth callback error:', authError);
        showToast('Authentication failed. Please try again.', 'error');
        localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams, navigate, showToast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f1115]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white text-lg">Completing sign in...</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
